import React from 'react'
import { Timestamp } from './Contacts/ContactAssociation'
import { cn } from 'utils/cn';

type TimeStampProps = {
    timestamps:Timestamp[];
    className?: string;
}

function Timestamps({timestamps,className}: TimeStampProps) {
  return (
    <div className={cn('p-4 border-primary-subtle',className)}>
        <div className="mb-2 px-1 text-[13px] font-semibold tracking-wider text-neutral-faded">
          TIMESTAMPS
        </div>
        <div>
          {timestamps?.map((t, i) => (
            <div
              key={t.label}
              className={`flex items-center justify-between px-1 py-2.5 ${
                i !== timestamps.length - 1 ? 'border-b border-primary-subtle' : ''
              }`}
            >
              <span className="text-[13.5px] text-neutral-faded">{t.label}</span>
              <span className="text-[13.5px] font-medium text-neutral-medium">{t.value}</span>
            </div>
          ))}
        </div>
      </div>
  )
}

export default Timestamps